<div fxLayout="column" fxLayoutGap="14px" class="app-full-height px-4 pt-4">
  <app-alert-text *ngIf="docket?.rolled_over_from !== null" type="info">
    <h2>Information</h2>
    <p>This invoice was rolled over from a previous invoice.</p>
    <p>
      <a [routerLink]="['/docket', docket.rolled_over_from]">Click here</a> to
      view the previous invoice.
    </p>
  </app-alert-text>
  <app-alert-text *ngIf="docket?.rolled_over_to !== null">
    <h2>Warning</h2>
    <p>This invoice has been rolled over to a new hire contract.</p>
    <p>
      <a [routerLink]="['/docket', docket.rolled_over_to]">Click here</a> to
      view the new hire contract.
    </p>
  </app-alert-text>
  <app-alert-text *ngIf="docket?.status === 'Transferred'" id="transferred-warning">
    <h2>Warning</h2>
    <p>
      This invoice has been transferred to your accounts package.
    </p>
  </app-alert-text>
  <div *ngIf="docket" class="flex flex-col md:flex-row md:space-y-0 space-y-4">
    <mat-card appearance="outlined" class="flex flex-col basis-1/3 md:basis-full md:order-2 md:mx-4">
      <mat-card-content>
        <h1 class="text-center">
          {{ statusHeading }}
          <ng-container *ngIf="!docket.account_reference; else invoiceNo">
            - {{ docket.id }}</ng-container>
          <ng-template #invoiceNo>
            - {{ docket.account_reference }}</ng-template>
        </h1>
        <h3 *ngIf="docket.closed" class="text-center">
          Closed: {{ docket.closed | amDateFormat: dateFormat }}
        </h3>
        @if((chargeables$ | async)?.length > 0) {
        <div fxLayout="row" fxLayoutAlign="center center">
          <button matTooltip="Print" data-cy="print" color="primary" mat-icon-button (click)="print()">
            <mat-icon>print</mat-icon>
          </button>
          <button matTooltip="Download" color="primary" mat-icon-button (click)="print(true)">
            <mat-icon>file_download</mat-icon>
          </button>
          <button matTooltip="Email" color="primary" mat-icon-button (click)="email()">
            <mat-icon>send</mat-icon>
          </button>
        </div>
        }
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined" class="flex flex-col basis-1/3 md:basis-full md:order-1">
      <mat-card-content>
        <div class="flex flex-col justify-start md:items-stretch items-stretch text-center md:text-left">
          <h2>Customer</h2>
          <div class="flex flex-row justify-start items-center md:justify-between gap-x-4">
            <p id="customer-name">
              <a *ngIf="docket" matTooltip="View Customer" matTooltip-position="right" md-autohide="false"
                routerLink="/customer/{{ docket?.customer_id }}">
                {{ docket?.customer | customerName }}
              </a>
            </p>
            <button mat-stroked-button (click)="changeCustomer()" [disabled]="isDocketLocked$ | async">
              Change
            </button>
          </div>
          <p>{{ docket?.customer | customerAddress }}</p>
          <p class="break-words">
            {{ docket?.customer | customerContactDetails }}
          </p>
          <app-document-contact [contactId]="docket?.contact_id" [customerId]="docket?.customer_id"
            (contactSelected)="updateDocketContact($event)"></app-document-contact>
          <app-integration-relationship-info [customer]="docket?.customer"></app-integration-relationship-info>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="flex flex-col basis-1/3 md:basis-full md:order-3" appearance="outlined" fxFlex.gt-sm="35"
      fxFlex="auto" fxFlexOrder.gt-sm="3">
      <mat-card-content>
        <div class="flex flex-col justify-start md:items-end items-center md:text-right">
          <h2>
            <ng-container *ngIf="docket?.account_reference === null">Contract Settings
            </ng-container>
            <ng-container *ngIf="docket?.account_reference !== null">Invoice Settings
            </ng-container>
          </h2>
          <p class="text-center md:text-right">
            <strong>Status:</strong> {{ docket?.status }}
            <a *ngIf="docket?.account_reference === null" (click)="addAccountsReference()">
              | Convert to Invoice</a>
            <ng-container *ngIf="docket?.account_reference !== null">
              <strong>Accounts Reference:</strong>
              {{ docket?.account_reference }}
              <ng-container *ngIf="docket?.account === 1">
                <ng-container *ngIf="docket?.xero_id; else noXeroInvoice">
                  <a href="https://invoicing.xero.com/edit/{{ docket?.xero_id }}">(Account)</a>
                </ng-container>
                <ng-template #noXeroInvoice> (Account)</ng-template>
              </ng-container>
              <ng-container *ngIf="docket?.account === 0">
                <ng-container *ngIf="docket?.xero_id; else noXeroCash">
                  <a href="https://invoicing.xero.com/edit/{{ docket?.xero_id }}">(Cash Invoice)</a>
                </ng-container>
                <ng-template #noXeroCash> (Cash Invoice)</ng-template>
              </ng-container>
            </ng-container>
          </p>
          <p *ngIf="docket?.account_reference !== null">
            <strong>Tax Rate:</strong>
            {{ docket?.tax_rate | percent: '1.0-2' }}
          </p>
          <p *ngIf="docket?.rollover_date">
            <strong>Rollover date:</strong>
            {{ docket?.rollover_date | amDateFormat: dateFormat }}
          </p>
          <ng-container *ngIf="docket.currency_code !== defaultCurrency">
            <p><strong>Currency:</strong> {{ docket?.currency_code }}</p>
            <p>
              <strong>Conversion Rate:</strong>
              {{ docket?.currency_rate | number: '1.2-2' }}
            </p>
          </ng-container>
          <p><strong>Purchase Order:</strong> {{ docket?.purchase_order }}</p>
          <div class="flex flex-row flex-wrap space-x-2">
            <button mat-stroked-button (click)="editSettings()">Edit</button>
            <button mat-stroked-button (click)="markAsTransferred()" *ngIf="docket?.status === 'To be transferred'">
              Mark as Transferred
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div fxLayout="column" *ngIf="docket" fxLayoutGap="14px">
    <app-hire-item-list-v2 #hireItemList [docketId]="docket?.id" [customerId]="docket?.customer_id"
      [defaultCurrency]="docket?.currency_code" [currency]="docket.currency_code" [currencyRate]="docket.currency_rate"
      [docketClosed]="docket?.closed !== null" (refetchDocket)="getDocket(docket.id)"
      (openPaymentDialog)="openPaymentDialog()" (itemsChanged)="updateHireItems($event)"
      [previewMode]="isDocketLocked$ | async"></app-hire-item-list-v2>

    <div class="mt-3 flex justify-center items-center" *ngIf="(consumableCount$ | async) === 0 && !showConsumables">
      <button id="add-consumable-items" mat-raised-button (click)="toggleShowConsumables()"
        [disabled]="isDocketLocked$ | async">
        Add Consumables
      </button>
    </div>
    <div [ngClass]="{
        'invisibile max-h-0 overflow-hidden flex flex-col justify-start items-stretch':
          !showConsumables
      }">
      <mat-card appearance="outlined" fxLayout="column" fxLayoutAlign="start stretch">
        <mat-card-content fxLayout="column" fxLayoutGap="14px" fxLayoutAlign="start stretch">
          <mat-card-title fxFlexAlign="center">
            <h2>Consumables</h2>
          </mat-card-title>
          <div class="w-full overflow-x-auto">
            <app-retail-item-list [docketId]="docket?.id" [canAdd]="true" [currency]="docket?.currency_code"
              [currencyRate]="docket?.currency_rate" [showGridButton]="true" [canEdit]="true"
              [parentType]="'hire docket'" [preview]="(isDocketLocked$ | async) === true"></app-retail-item-list>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="16px" class="mt-2">
      <div fxLayout="column" fxLayoutGap="16px" fxFlex.gt-sm="70">
        <div class="border border-gray-300 p-3" fxLayout="column" fxLayoutGap="14px">
          <app-signature-section [docket]="docket" [stage]="
              docket?.account_reference === null ? 'Hire Contract' : 'Invoice'
            "></app-signature-section>
        </div>
        <deliveries [deliverableId]="docket.id" deliverableType="docket" [deliverableCustomer]="docket.customer"
          [defaultCurrency]="defaultCurrency" [deliverableCurrency]="docket.currency_code"
          [currencyRate]="docket.currency_rate" [canAdd]="(isDocketLocked$ | async) !== true"
          [canEdit]="(isDocketLocked$ | async) !== true" (deliveriesUpdated)="onDeliveriesUpdated($event)"
          [refreshDeliveryData$]="refreshDataDependentOnHireItems$"></deliveries>
      </div>

      <app-price-container-v2 *ngIf="docket" fxFlex.gt-sm="30" paymentableType="docket"
        (showRoundDialog)="showRoundDialog()" [enableRounding]="true" [paymentableId]="docket?.id"
        [currency]="docket.currency_code" [canAddPayments]="true" [chargeableItems]="chargeables$ | async"
        [deliveryCharges]="deliveryCharges$ | async" [currencyRate]="docket.currency_rate" [discount]="docket.discount"
        [enableDiscount]="true" (editDiscount)="editDiscount()" (paymentsChanged)="newPayment()" />
    </div>
    <app-comments-and-emails [source]="emailListSource$ | async">
      <app-comments class="self-stretch flex flex-row justify-center" [type]="'docket'" [id]="docket?.id"
        [comments]="docket?.comments"></app-comments>
    </app-comments-and-emails>

  </div>
</div>
<iframe [style.display]="'none'" frameborder="0" #printFrame></iframe>